import { render } from "./Forecasts.vue?vue&type=template&id=02c3256a"
import script from "./Forecasts.vue?vue&type=script&lang=ts"
export * from "./Forecasts.vue?vue&type=script&lang=ts"
script.render = render

export default script